import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service, {
    getDataFlowV2FieldErrors,
} from "src/modules/data-protection/apis/DataFlowV2Service";
import { DATA_FLOW_ENDPOINTS_QUERY_KEY } from "./useDataFlowEndpoints";

const useCreateEndpoint = ({ t, onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (payload) => {
            const service = DataFlowV2Service.getInstance();
            const response = await service.createEndpoint(payload);

            return response?.data || {};
        },
        onSuccess: (endpoint) => {
            queryClient.invalidateQueries({
                queryKey: [DATA_FLOW_ENDPOINTS_QUERY_KEY],
            });

            if (typeof onSuccess === "function") {
                onSuccess(endpoint);
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            const fieldErrors = getDataFlowV2FieldErrors(error);

            if (typeof onError === "function") {
                onError(fieldErrors);
            }

            if (!Object.keys(fieldErrors).length) {
                toast(t("Failed to create endpoint."), {
                    type: "error",
                });
            }
        },
    });

    return {
        createEndpoint: mutation.mutate,
        isCreating: mutation.isLoading,
    };
};

export default useCreateEndpoint;
